/**
 * @description validateURL
 * @param {string} urlStr - the URL to validate
 * @returns {boolean} - true if the URL is valid, false otherwise
 */
function validateURL(urlStr) {
	try {
		const url = new URL(urlStr);

		if (url.protocol !== "https:") {
			return false;
		}

		if (urlStr !== encodeURI(urlStr)) {
			return false;
		}

		const hostnameParts = url.hostname.split('.');
		const isValidDomain = hostnameParts.length > 1 && hostnameParts.every(part => part.length > 0);

		return isValidDomain && hostnameParts[hostnameParts.length - 1].length > 1;
	} catch (err) {

		return false;
	}
}

export default validateURL
